import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/global.scss'
import store from './store'
import VueTheMask from 'vue-the-mask';
import { sendErrorToDiscord } from "./utils/errorHandler";

const app = createApp(App)

app.config.errorHandler = (err) => {
  if( process.env.NODE_ENV === 'development' ) return

  sendErrorToDiscord(err.message, err.stack);
};

window.onerror = (message, source, lineno, colno, error) => {
  if( process.env.NODE_ENV === 'development' ) return

  sendErrorToDiscord(message, error?.stack);
};

window.addEventListener("unhandledrejection", (event) => {
  if( process.env.NODE_ENV === 'development' ) return

  sendErrorToDiscord(event.reason?.message, event.reason?.stack);
});

app.use(router)
app.use(store)
app.use(VueTheMask)
app.mount('#app')
